import React, { useEffect, useState } from 'react';
import { TreasurerDigestCard } from './TreasurerDigestCard';
import { CalendarClock } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;
const http = (path, opts = {}) => fetch(`${API}/api${path}`, { credentials: 'include', headers: { 'Content-Type': 'application/json' }, ...opts })
  .then(async (r) => { const d = await r.json().catch(() => ({})); if (!r.ok) throw new Error(d.detail || 'Request failed'); return d; });

const DAYS = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
const NTH = [[1, 'first'], [2, 'second'], [3, 'third'], [4, 'fourth'], [5, 'last']];
const sel = 'border rounded px-2 py-1 text-sm bg-white';
const border = { borderColor: 'rgba(0,0,0,0.2)' };

// Monthly auto-email of the Treasurer report (previous calendar month) to committee + admins.
export default function TreasurerScheduleCard() {
  const [cfg, setCfg] = useState(null);
  const [err, setErr] = useState('');

  useEffect(() => { http('/admin/basiq/report/schedule').then(setCfg).catch(() => {}); }, []);

  const save = async (patch) => {
    const next = { ...cfg, ...patch };
    setCfg(next); setErr('');
    try { setCfg(await http('/admin/basiq/report/schedule', { method: 'PUT', body: JSON.stringify(next) })); }
    catch (e) { setErr(e.message); }
  };

  if (!cfg) return null;
  const dis = !cfg.enabled;
  return (
    <div className="mt-4 pt-4 border-t" style={{ borderColor: 'rgba(0,0,0,0.08)' }} data-testid="treasurer-schedule-card">
      <label className="flex items-center gap-2 text-sm font-title" style={{ color: 'var(--navy)' }}>
        <input type="checkbox" checked={!!cfg.enabled} onChange={(e) => save({ enabled: e.target.checked })} data-testid="treasurer-schedule-enabled" />
        <CalendarClock size={15} /> Email last month's report to the committee automatically
      </label>
      <div className="flex items-center gap-2 flex-wrap mt-2 text-sm" style={{ opacity: dis ? 0.5 : 1 }}>
        <span>Send on</span>
        <select value={cfg.mode} disabled={dis} onChange={(e) => save({ mode: e.target.value })} className={sel} style={border} data-testid="treasurer-schedule-mode">
          <option value="day_of_month">a day of the month</option>
          <option value="nth_weekday">a weekday pattern</option>
        </select>
        {cfg.mode === 'day_of_month' ? (
          <select value={cfg.day_of_month} disabled={dis} onChange={(e) => save({ day_of_month: Number(e.target.value) })} className={sel} style={border} data-testid="treasurer-schedule-dom">
            {Array.from({ length: 28 }, (_, i) => i + 1).map((d) => <option key={d} value={d}>{d}</option>)}
          </select>
        ) : (
          <>
            <span>the</span>
            <select value={cfg.nth} disabled={dis} onChange={(e) => save({ nth: Number(e.target.value) })} className={sel} style={border} data-testid="treasurer-schedule-nth">
              {NTH.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
            </select>
            <select value={cfg.weekday} disabled={dis} onChange={(e) => save({ weekday: Number(e.target.value) })} className={sel} style={border} data-testid="treasurer-schedule-weekday">
              {DAYS.map((d, i) => <option key={d} value={i}>{d}</option>)}
            </select>
          </>
        )}
        <span>of every month.</span>
      </div>
      <p className="text-xs mt-1" style={{ color: 'var(--olive)' }} data-testid="treasurer-schedule-summary">
        {cfg.enabled ? `Scheduled for ${cfg.summary}.` : 'Automatic sending is off.'}
        {cfg.last_sent ? ` Last automatic send: ${new Date(cfg.last_sent).toLocaleDateString()}.` : ' Not sent automatically yet.'}
      </p>
      {err && <p className="text-xs mt-1" style={{ color: '#8a1f11' }} data-testid="treasurer-schedule-error">{err}</p>}
      <TreasurerDigestCard cfg={cfg} save={save} http={http} />
    </div>
  );
}
